import { Building2, History, Users, UserPlus, LayoutTemplate, ShieldCheck } from 'lucide-react';

/**
 * The Settings tabs and who sees each. Kept apart from SettingsLayout so the Sidebar
 * can read it too without importing the layout that renders the Sidebar.
 *
 * needsTeam: only shown once team logins are switched on for this deployment.
 */
export const SETTINGS_TABS = [
  {
    key: 'company',
    label: 'Company Profile',
    icon: Building2,
    path: '/hirewithus/settings/companysetup',
    permission: 'settings.company',
    matches: [
      '/hirewithus/settings/companysetup',
      '/hirewithus/settings/foundingsetup',
      '/hirewithus/settings/socials',
      '/hirewithus/settings/contact',
    ],
  },
  {
    key: 'team',
    label: 'Team & Roles',
    icon: ShieldCheck,
    path: '/hirewithus/settings/team',
    permission: 'team.manage',
    needsTeam: true,
    matches: ['/hirewithus/settings/team'],
  },
  {
    key: 'interviewers',
    label: 'Saved Interviewers',
    icon: Users,
    path: '/hirewithus/settings/interviewers',
    permission: 'settings.interviewers',
    matches: ['/hirewithus/settings/interviewers'],
  },
  {
    key: 'recruiters',
    label: 'Vendor recruiters',
    icon: UserPlus,
    path: '/hirewithus/settings/recruiters',
    permission: 'settings.vendors',
    matches: ['/hirewithus/settings/recruiters'],
  },
  {
    key: 'templates',
    label: 'Question templates',
    icon: LayoutTemplate,
    path: '/hirewithus/settings/templates',
    permission: 'tests.templates',
    // One tab for every interview-type builder — stays active on each sub-page.
    matches: [
      '/hirewithus/settings/templates',
      '/hirewithus/settings/aptitude-builder',
      '/hirewithus/settings/pnb-builder',
    ],
  },
  {
    key: 'activity',
    label: 'Activity',
    icon: History,
    path: '/hirewithus/settings/activity',
    permission: 'audit.view',
    matches: ['/hirewithus/settings/activity'],
  },
];

export const SETTINGS_PERMISSIONS = SETTINGS_TABS.map((tab) => tab.permission);

/** The first Settings page this person can open. */
export const firstSettingsPath = (can) =>
  (SETTINGS_TABS.find((tab) => can(tab.permission)) || SETTINGS_TABS[0]).path;
